import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import './lisa-ui.css';
import reportWebVitals from './reportWebVitals';
import { Canvas, PageContainer } from 'core';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'sqx-frame': {src?:string,"sqx:params"?:any;status?:string,layer?:any,db?:string}
      'ace-editor':{style:React.CSSProperties}
    }
  }
  
}



function generateSignin(onClose){
  let div = document.createElement("div");
  div.setAttribute("style","pointer-events:all");
  let props = {"@no_redirect":true};
  let dialog = <PageContainer page={{name:"pages/public/log_in",props}}/>;
  let canvas = new Canvas(null);
  
  dialog = React.cloneElement(dialog,{key:"login",layer:"dialog",onClose:onClose,parent:canvas});
  

  ReactDOM.render(dialog, div);
  return div;
}

let sqx = window["sqx"];
if (sqx){
  sqx.generateSignin = generateSignin;
}



let content = <App />

ReactDOM.render(
  <React.StrictMode>
    {content}
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();





